function formatProductMoney(cents) {
  var currency = window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'USD';
  return (cents / 100).toLocaleString(document.documentElement.lang || 'en-US', { style: 'currency', currency: currency });
}

/* locale-aware strings injected by layout/theme.liquid (English fallback) */
function pdpT(key, fallback) {
  return (window.OUGIST && window.OUGIST.i18n && window.OUGIST.i18n[key]) || fallback;
}

function initMainProduct(root) {
  if (!root || root.dataset.mainProductInitialized) return;
  root.dataset.mainProductInitialized = 'true';
    /* gallery stage switching (images + videos) */
    var stage = root.querySelector('[data-stage]');
    var badge = stage ? stage.querySelector('.pdp__sale-badge') : null;
    if (stage) {
      var mediaAnchor = stage.querySelector('[data-gallery-prev]') || badge;
      var thumbButtons = Array.prototype.slice.call(root.querySelectorAll('[data-thumb-kind]'));
      thumbButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var kind = btn.getAttribute('data-thumb-kind');
          var current = stage.querySelector('img, video, iframe');
          if (current && current.tagName === 'VIDEO' && current.pause) current.pause();
          if (current) current.remove();
          var insertImage = function () {
            var img = document.createElement('img');
            img.src = btn.getAttribute('data-thumb-src');
            img.alt = btn.getAttribute('data-thumb-alt') || '';
            img.width = 1000;
            img.height = 1000;
            stage.insertBefore(img, mediaAnchor);
          };
          if (kind === 'image') {
            insertImage();
          } else {
            var src = root.querySelector('[data-video-source="' + btn.getAttribute('data-thumb-video') + '"]');
            if (src && src.firstElementChild) {
              var clone = src.firstElementChild.cloneNode(true);
              /* Gallery videos autoplay only after navigation selects them,
                 and always remain muted for browser and shopper safety. */
              if (clone.tagName === 'VIDEO') {
                clone.setAttribute('autoplay', '');
                clone.setAttribute('muted', '');
                clone.muted = true;
                clone.defaultMuted = true;
              }
              stage.insertBefore(clone, mediaAnchor);
              if (clone.tagName === 'VIDEO' && clone.play) {
                var playing = clone.play();
                if (playing && playing.catch) playing.catch(function () {});
              }
            } else {
              /* video source missing — fall back to the media image instead of a blank stage */
              insertImage();
            }
          }
          root.querySelectorAll('.pdp__thumb').forEach(function (t) { t.classList.remove('pdp__thumb--active'); });
          btn.classList.add('pdp__thumb--active');
        });
      });
      var showAdjacentMedia = function (direction) {
        if (!thumbButtons.length) return;
        var activeIndex = thumbButtons.findIndex(function (thumb) {
          return thumb.classList.contains('pdp__thumb--active');
        });
        if (activeIndex < 0) activeIndex = 0;
        var nextIndex = (activeIndex + direction + thumbButtons.length) % thumbButtons.length;
        thumbButtons[nextIndex].click();
        if (thumbButtons[nextIndex].scrollIntoView) {
          thumbButtons[nextIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
        }
      };
      var previousButton = stage.querySelector('[data-gallery-prev]');
      var nextButton = stage.querySelector('[data-gallery-next]');
      if (previousButton) previousButton.addEventListener('click', function () { showAdjacentMedia(-1); });
      if (nextButton) nextButton.addEventListener('click', function () { showAdjacentMedia(1); });
    }
    /* Variant images use the same gallery behavior as thumbnail navigation.
       A direct image fallback also works when thumbnails are hidden or capped. */
    var showVariantMedia = function (src) {
      if (!stage) return;
      var mediaId = src.getAttribute('data-featured-media-id');
      var mediaSrc = src.getAttribute('data-featured-media-src');
      if (!mediaId || !mediaSrc) return;
      var thumb = root.querySelector('[data-thumb-video="media-video-' + mediaId + '"]');
      if (thumb) { thumb.click(); return; }
      var current = stage.querySelector('img, video, iframe');
      if (current && current.tagName === 'VIDEO' && current.pause) current.pause();
      if (current) current.remove();
      var img = document.createElement('img');
      img.src = mediaSrc;
      img.alt = src.getAttribute('data-featured-media-alt') || '';
      img.width = 1000;
      img.height = 1000;
      stage.insertBefore(img, mediaAnchor);
      root.querySelectorAll('.pdp__thumb').forEach(function (t) { t.classList.remove('pdp__thumb--active'); });
    };
    /* qty stepper */
    root.querySelectorAll('[data-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        /* scope to the stepper's own .pdp__qty so a second buy form's
           quantity input is never touched */
        var scope = btn.closest('.pdp__qty');
        var input = scope ? scope.querySelector('input[name="quantity"]') : null;
        if (!input) return;
        var next = parseInt(input.value || '1', 10) + parseInt(btn.getAttribute('data-qty'), 10);
        input.value = Math.min(99, Math.max(1, next));
      });
    });
    /* AJAX add to cart — target every real buy form by class (two buy_buttons
       blocks in one section each render their own form); the hidden
       installment helper form in the price block also posts to /cart/add */
    var buyForms = root.querySelectorAll('form.pdp__form');
    buyForms.forEach(function (f) { f.setAttribute('data-ajax-cart', ''); });
    /* the sticky bar keeps driving the first form */
    var form = buyForms[0];
    /* custom buy now — add to cart, then go straight to checkout */
    root.querySelectorAll('[data-buy-now]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        /* the button renders inside its form (before endform), so closest()
           finds the right one; fall back to the first form just in case */
        var f = btn.closest('form') || form;
        if (!f) return;
        var data = new FormData(f);
        /* never post without a variant id */
        if (!data.get('id')) return;
        btn.disabled = true;
        fetch('/cart/add.js', { method: 'POST', body: data })
          .then(function (r) {
            if (!r.ok) throw new Error('add failed');
            window.location.href = '/checkout';
          })
          .catch(function () { btn.disabled = false; });
      });
    });
    /* The fixed bar is rendered beside the semantic product <section>, but
       inside Shopify's section wrapper. Search that wrapper so the bar is
       available without widening product queries to the whole document. */
    var sectionWrapper = root.parentElement;
    var bar = sectionWrapper && sectionWrapper.querySelector('[data-sticky-bar]');
    var stickyAtc = bar && bar.querySelector('[data-sticky-atc]');
    if (stickyAtc && form) {
      stickyAtc.addEventListener('click', function () {
        if (form.requestSubmit) {
          form.requestSubmit();
          return;
        }
        /* older browsers: click the real submit button so the submit event
           (and the AJAX handler) still fires */
        var submitBtn = form.querySelector('[type="submit"]');
        if (submitBtn) { submitBtn.click(); } else { form.submit(); }
      });
    }
    /* variant picker and buy buttons are separate blocks: on change, sync the
       hidden variant id plus price, compare price, SKU, sale badges, stock
       note and ATC state from the data attributes on the selected option.
       One buy_buttons block = one form = one hidden id input; sync them all
       so a second buy form can never post a stale variant id. */
    var idInputs = root.querySelectorAll('[data-variant-id-input]');
    var priceEls = (sectionWrapper || root).querySelectorAll('[data-price-value]');
    var compareEl = root.querySelector('[data-compare-value]');
    var saleTag = root.querySelector('[data-sale-tag]');
    var skuEl = root.querySelector('.pdp__sku-value');
    var stockNote = root.querySelector('[data-stock-note]');
    var mainAtc = root.querySelector('.pdp__atc');
    var atcBtns = [];
    root.querySelectorAll('.pdp__atc').forEach(function (btn) { atcBtns.push(btn); });
    if (stickyAtc) atcBtns.push(stickyAtc);
    /* custom buy-now follows the same sold-out disable/restore as ATC; it has
       no [data-atc-label], so the label swap below simply skips it */
    root.querySelectorAll('[data-buy-now]').forEach(function (btn) { atcBtns.push(btn); });
    atcBtns.forEach(function (btn) {
      var label = btn.querySelector('[data-atc-label]');
      /* liquid renders data-default-label with the available-state copy; only
         fall back to the current text when it is missing and the variant is
         available, so a sold-out deep link never poisons the restore value */
      if (label && !btn.hasAttribute('data-default-label') && !btn.disabled) {
        btn.setAttribute('data-default-label', label.textContent);
      }
    });
    root.querySelectorAll('[data-variant-source]').forEach(function (input) {
      input.addEventListener('change', function () {
        idInputs.forEach(function (el) { el.value = input.value; });
        /* dropdowns carry the variant data on the selected <option>, pills on the input itself */
        var src = input.tagName === 'SELECT' ? input.options[input.selectedIndex] : input;
        if (!src) return;
        showVariantMedia(src);
        var priceCents = parseInt(src.getAttribute('data-price-cents') || '0', 10);
        var compareCents = parseInt(src.getAttribute('data-compare-cents') || '0', 10);
        var price = formatProductMoney(priceCents);
        var compare = compareCents > priceCents ? formatProductMoney(compareCents) : '';
        var available = src.getAttribute('data-available') !== 'false';
        priceEls.forEach(function (el) { el.textContent = price; });
        if (compareEl) {
          compareEl.textContent = compare || '';
          compareEl.style.display = compare ? '' : 'none';
        }
        if (saleTag) saleTag.style.display = compare ? '' : 'none';
        if (badge) {
          if (compareCents > priceCents && priceCents > 0) {
            badge.textContent = pdpT('save', 'Save') + ' ' + Math.round(((compareCents - priceCents) * 100) / compareCents) + '%';
            badge.style.display = '';
          } else {
            badge.style.display = 'none';
          }
        }
        if (skuEl) skuEl.textContent = src.getAttribute('data-sku') || '';
        if (stockNote) stockNote.textContent = available ? stockNote.getAttribute('data-stock-note') : pdpT('soldOut', 'Sold Out');
        atcBtns.forEach(function (btn) {
          btn.disabled = !available;
          var label = btn.querySelector('[data-atc-label]');
          if (label) label.textContent = available ? btn.getAttribute('data-default-label') : pdpT('soldOut', 'Sold Out');
        });
        /* let other sections (FBT's current-product item) follow the selected
           variant; single-variant products render no [data-variant-source],
           so this never fires for them */
        document.dispatchEvent(new CustomEvent('ougist:variant-change', {
          detail: { id: input.value, price: parseInt(src.getAttribute('data-price-cents') || '0', 10) }
        }));
      });
    });
    /* Show only after the main ATC has passed above the viewport. A plain
       !isIntersecting check also matches a button that is still below the
       fold on first load, which would open the sticky bar too early. */
    if (bar && mainAtc) {
      var syncStickyBar = function (rect) {
        var buttonRect = rect && typeof rect.bottom === 'number' ? rect : mainAtc.getBoundingClientRect();
        var passedMainAtc = buttonRect.bottom <= 0;
        if (bar.toggleAttribute) {
          bar.toggleAttribute('data-open', passedMainAtc);
        } else if (passedMainAtc) {
          bar.setAttribute('data-open', '');
        } else {
          bar.removeAttribute('data-open');
        }
      };
      var stickyFrame;
      var requestStickySync = function () {
        if (stickyFrame) return;
        stickyFrame = window.requestAnimationFrame(function () {
          stickyFrame = null;
          syncStickyBar();
        });
      };
      var observer;
      if ('IntersectionObserver' in window) {
        observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) { syncStickyBar(entry.boundingClientRect); });
        });
        observer.observe(mainAtc);
      }
      /* A fast swipe can move the button from below to above the viewport
         between observer frames. The throttled scroll path covers that jump. */
      window.addEventListener('scroll', requestStickySync, { passive: true });
      window.addEventListener('resize', requestStickySync);
      syncStickyBar();
      document.addEventListener('shopify:section:unload', function (event) {
        if (!event.target || !event.target.contains || !event.target.contains(bar)) return;
        if (observer) observer.disconnect();
        if (stickyFrame) window.cancelAnimationFrame(stickyFrame);
        window.removeEventListener('scroll', requestStickySync);
        window.removeEventListener('resize', requestStickySync);
      });
      document.addEventListener('shopify:section:load', function (event) {
        if (event.target && event.target.contains && event.target.contains(bar)) bar.removeAttribute('data-open');
      });
    }
}

document.querySelectorAll('[data-main-product-section]').forEach(initMainProduct);
document.addEventListener('shopify:section:load', function (event) {
  var root = event.target.matches && event.target.matches('[data-main-product-section]')
    ? event.target
    : event.target.querySelector && event.target.querySelector('[data-main-product-section]');
  if (root) initMainProduct(root);
});
